import { Space } from 'antd'
import { isEmpty, isNil } from 'lodash'

import { QuotaEntity } from '@eastcoal/api/trade/interface'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { ArrayField } from '@eastcoal/formily/exports/core'
import {
  ObjectField,
  observer,
  useField,
  useForm
} from '@eastcoal/formily/exports/react'

import { MathOperator } from '@eastcoal/shared/enums/MathOperator'

import { QuotaTypeSelect } from './components/QuotaTypeSelect'
import { QuotaValueInputGroup } from './components/QuotaValueInputGroup'

export const ListingQuotaList = observer(() => {
  const { value, errors } = useField<ArrayField>()
  const form = useForm()

  const isCalorificValue = (name?: string) => name === '发热量'

  return isEmpty(value) ? null : (
    <>
      {value?.map((quota, index) => {
        const quotaError = errors.find(error =>
          error.path?.includes(`${index}`)
        )
        const hasError = (quotaError?.messages?.length || 0) > 0

        return (
          <FormItem.Base
            key={index}
            feedbackStatus={hasError ? 'error' : undefined}
            feedbackText={quotaError?.messages?.[0]}
            label={quota.name}
            labelWidth={120}
            wrapperWidth={500}
          >
            <ObjectField
              key={index}
              name={index}
              validator={(value: QuotaEntity) => {
                // 在 validator 内部实时获取计价方式，避免 observer 闭包旧值
                const pricingMethodName = form.values.pricingMethodName
                const needRequired =
                  !!pricingMethodName?.includes('卡') &&
                  isCalorificValue(quota.name)

                if (!needRequired) {
                  return undefined
                }

                if (isNil(value.type)) {
                  return '指标类型不能为空'
                }

                if (isNil(value.value1)) {
                  return '最小值不能为空'
                }

                if (value.type === MathOperator.RANGE && isNil(value.value2)) {
                  return '最大值不能为空'
                }
              }}
            >
              <Space>
                <QuotaTypeSelect />
                <QuotaValueInputGroup />
              </Space>
            </ObjectField>
          </FormItem.Base>
        )
      })}
    </>
  )
})
